<template>
  <div class="patientRecordWrapper">
    <div v-if="patient?.headUrl" class="avatar">
      <img :src="patient.headUrl" alt="" />
    </div>
    <div class="basicInfo">
      <div v-if="getPatientDisplayName(patient)" class="name">
        {{ getPatientDisplayName(patient) }}
      </div>
      <div v-if="[0, 1].includes(patient?.gender)" class="sex">
        {{ ['女', '男'][patient.gender] }}
      </div>
      <div v-if="patient?.age" class="age">{{ patient.age }}岁</div>
    </div>
  </div>
</template>

<script setup>
import { defineProps } from 'vue'
defineProps({
  patient: {
    type: Object,
    default: () => {}
  }
})
// 获取患者展示姓名
const getPatientDisplayName = patient => {
  if (!patient) return ''
  return patient.name || patient.nickName || patient.ucUserId || ''
}
</script>

<style scoped lang="scss">
.patientRecordWrapper {
  display: flex;
  align-items: center;
  height: 100%;
  padding: 12px 24px;
  border-bottom: 1px solid #eff4f9;
  background: #f3f6fa;
  .avatar {
    border-radius: 8px;
    margin-right: 12px;

    img {
      width: 36px;
      height: 36px;
    }
  }

  .basicInfo {
    display: flex;
    align-items: center;
    color: #333;
    font-weight: 600;

    .name {
      margin-right: 12px;
      font-size: 17px;
    }

    .sex,
    .age {
      font-size: 14px;
    }

    .sex {
      margin-right: 12px;
    }
  }
}
</style>
